export default "__VITE_ASSET__BqLtn0wD__"